import { render, staticRenderFns } from "./SwitchType.vue?vue&type=template&id=d5ad48f6&scoped=true"
import script from "./SwitchType.vue?vue&type=script&lang=js"
export * from "./SwitchType.vue?vue&type=script&lang=js"
import style0 from "./SwitchType.vue?vue&type=style&index=0&id=d5ad48f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5ad48f6",
  null
  
)

export default component.exports